export default function playAudio(n: number) {
    const padded = padNumber(n);
    let audio = new Audio(`/audio/${padded}.mp3`);
    audio.addEventListener("ended", () => {
        audio.remove();
        audio.srcObject = null;
    });
    audio.play().catch((e) => {
        console.error(e);
        alert("Error playing audio - Connect to the internet and try again");
    });
}

function padNumber(n: number): string {
    return (n < 10) ? `0${n}` : `${n}`;
}